import { Link, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const NAV_MENUS = [
  { label: "Auto Wash", items: [
    { to: "/membership", label: "Membership" },
    { to: "/pricing#auto-wash", label: "Wash Menu & Prices" },
    { to: "/pricing#how-to-use", label: "How To Use" },
  ] },
  { label: "Self Serve", items: [
    { to: "/self-serve", label: "About" },
    { to: "/pricing#self-serve", label: "Prices" },
    { to: "/pricing#vacuum", label: "Vacuums" },
    { to: "/pricing#mat-cleaner", label: "Mat Cleaner" },
  ] },
  { label: "Dog Wash", items: [
    { to: "/dog-wash", label: "About" },
    { to: "/pricing#dog-wash", label: "Prices" },
  ] },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export function NavDropdown({ label, items }) {
  const { pathname } = useLocation();
  const active = items.some((i) => i.to.split("#")[0] === pathname && !i.to.includes("#"));
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger data-testid={`nav-menu-${slug(label)}`}
        className={`overline flex items-center gap-1 outline-none transition-colors hover:text-white data-[state=open]:text-white ${active ? "text-white" : "text-muted-foreground"}`}>
        {label} <ChevronDown className="w-3 h-3 transition-transform duration-200 [[data-state=open]>&]:rotate-180" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={14} className="min-w-[200px] rounded-none border-white/10 bg-black/90 backdrop-blur-xl p-1">
        {items.map((i) => (
          <DropdownMenuItem key={i.to} asChild className="rounded-none cursor-pointer focus:bg-volt focus:text-white">
            <Link to={i.to} data-testid={`nav-item-${slug(label)}-${slug(i.label)}`} className="overline py-3 px-3">{i.label}</Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
